import React, { useContext } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { AppContext } from '../../../context/appContext';

const Header = ({ img, content, headerImage, headerColor }) => {
  const [settings] = useContext(AppContext);
  const generateHtml = () => ({ __html: content });

  return (
    <Root imageUrl={headerImage} backgroundColor={headerColor}>
      <div className="overLay">
        <div
          className="leftSide"
          style={{ backgroundImage: img ? `url('${img}')` : '' }}
        >
          {!img && 'logó helye'}
        </div>
        <div className="rightSide">
          <p className="hashTag">
            <strong>{settings?.title || '#ÉRINTÉSMENTES'}</strong>
          </p>
          {content && (
            <Content dangerouslySetInnerHTML={content && generateHtml()} />
          )}
        </div>
      </div>
    </Root>
  );
};

export default Header;

Header.propTypes = {
  img: PropTypes.string,
  content: PropTypes.string,
  headerImage: PropTypes.string,
  headerColor: PropTypes.string
};

Header.defaultProps = {
  img: '',
  content: 'Elérhetőség helye',
  headerImage: null,
  headerColor: null
};

const Root = styled.div`
  background-image: ${props => `url(${props.imageUrl})`};
  width: 100%;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 6em;
  padding-bottom: 5em;

  @media (max-width: 800px) {
    padding: 0;
  }

  & .overLay {
    background-color: ${props => `${props.backgroundColor}`};
    max-width: 1300px;
    min-height: 200px;
    flex: 1;
    height: 100%;
    border-radius: 50px;
    display: flex;
    justify-content: center;
    align-content: center;
    padding-bottom: 2em;
    padding-top: 1em;

    @media (max-width: 800px) {
      flex-direction: column;
      border-radius: 0;
    }

    & .leftSide {
      max-height: 270px;
    }

    & .leftSide,
    .rightSide {
      max-width: 50%;
      flex-basis: 600px;
      height: auto;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      flex-wrap: wrap;
      padding: 0 16px;
      flex-shrink: 1;
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;

      @media (max-width: 1000px) {
        font-size: 0.8em;
      }

      @media (max-width: 800px) {
        max-width: 100%;
        justify-content: center;
        align-items: center;
        font-size: 1em;
        flex-basis: 300px;
      }

      & img {
        max-width: 100%;
        height: auto;
      }

      & .hashTag {
        font-size: 1.5em;
        margin: 0%;
        width: 100%;
        text-align: left;
      }
    }
  }
`;

const Content = styled.div`
  width: 100%;
  font-size: 1.2em;

  & p {
    margin: 0;

    @media (max-width: 800px) {
      font-size: 0.8em;
      text-align: center;
    }
  }

  & h3 {
    margin-top: 0;

    &:not(:first-child) {
      margin-bottom: 4px;

      @media (max-width: 800px) {
        text-align: center;
      }
    }
  }
`;
